/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Scans({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M4.11 2.18a7 7 0 0 1 8.396.464l1.362-1.361a.6.6 0 0 1 .85.848L8.423 8.424a.6.6 0 0 1-.848-.848l1.931-1.933a2.8 2.8 0 0 0-1.232-.43A2.8 2.8 0 1 0 10.8 8.001.6.6 0 1 1 12 8a4 4 0 1 1-3.608-3.982c.72.071 1.4.338 1.977.762l1.285-1.284a5.798 5.798 0 0 0-9.013 6.722 5.8 5.8 0 0 0 6.49 3.47 5.8 5.8 0 0 0 4.67-5.688.6.6 0 1 1 1.2 0A7 7 0 1 1 4.11 2.18" /></svg>;
}
;